import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import RegulatoryPage from './pages/RegulatoryPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!window.location.hash.includes('#')) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

function App() {
  const redirectToSection = (section) => (
    <Navigate to={`/risk-disclosures#${section}`} replace />
  );

  return (
    <Router>
      <div className="app-container">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/risk-disclosures" element={<RegulatoryPage />} />
          <Route path="/privacy-policy" element={redirectToSection('privacy')} />
          <Route path="/terms-of-use" element={redirectToSection('terms')} />
          <Route path="/terms-and-conditions" element={redirectToSection('terms')} />
          <Route path="/investor-charter" element={redirectToSection('charter')} />
          <Route path="/disclosure" element={redirectToSection('disclosure')} />
          <Route path="/investor-grievances" element={redirectToSection('grievances')} />
          <Route path="/accessibility-statement" element={redirectToSection('accessibility')} />
          <Route path="/complaint-data" element={redirectToSection('complaints')} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;